/* eslint-disable max-classes-per-file */
/* eslint-disable no-useless-constructor */
import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when user clicks on "What service do you need?" to open the dropdown of all the services available
 * [Event Spec M2 Intuitive mWeb Homepage Form](https://roverdotcom.atlassian.net/wiki/spaces/BKS/pages/3612672002/Event+Spec+M2+Intuitive+mWeb+Homepage+Form)
 *
 * &nbsp;
 */
export class MobileWebHomePageServiceTypeDropdownClick extends AnalyticsEvent {
  eventName = 'mobileweb-homepage-servicetype-dropdown-click';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.recommendations.browse_search;

  constructor(eventProperties: { serviceType?: string }) {
    super(eventProperties);
  }
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when user changes the service selected on the simplified mobile owner search.
 * [Event Spec M2 Intuitive mWeb Homepage Form](https://roverdotcom.atlassian.net/wiki/spaces/BKS/pages/3612672002/Event+Spec+M2+Intuitive+mWeb+Homepage+Form)
 *
 * &nbsp;
 */
export class MobileWebHomePageServiceTypeChange extends AnalyticsEvent {
  eventName = 'mobileweb-homepage-servicetype-change';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.recommendations.browse_search;

  constructor(eventProperties: { serviceType?: string }) {
    super(eventProperties);
  }
}
